export default "__VITE_ASSET__Dio9se5o__"